module.exports = __webpack_public_path__ + "static/media/smartid-quiz-ogimage.c5ec2765.png";